import React, { Component } from 'react';
import { Layout, Row, Col, Dropdown, Button, Menu, Icon, Input, Breadcrumb } from 'antd';
import { NavLink, withRouter } from 'react-router-dom';
import * as actions from '../../actions/index';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import Skeleton from 'react-loading-skeleton';
import SmoothCollapse from 'react-smooth-collapse';
import './layout.css';
const { Header } = Layout;
const Search = Input.Search;

const SubMenu = Menu.SubMenu;

const menu = (
  <Menu>
    <Menu.Item key="1"><Icon type="user" />1st menu item</Menu.Item>
    <Menu.Item key="2"><Icon type="user" />2nd menu item</Menu.Item>
    <Menu.Item key="3"><Icon type="user" />3rd item</Menu.Item>
  </Menu>
);
class NESAHeader extends Component {

  constructor(props) {
    super(props)
    this.logout = this.logout.bind(this);
    this.submenu = this.submenu.bind(this);
    this.state = {
      ...props,
      SubMenu: false
    }
  }

  logout = () => {
    this.props.actions.logout()
  }

  componentDidMount = () => {
    //this.props.actions.getProfileInfo()
  }

  submenu = (ShoworHide) => {
    this.setState({
      SubMenu: ShoworHide
    })
  }

  render() {
    return (
      <div className='nesa-layout'>

        <SmoothCollapse expanded={this.state.SubMenu}>
          <div className="content">
            <ul className="rightItems">
              <li><a target="_blank" href="https://scouting.org">Scouting.org</a></li>
              <li><a target="_blank" href="https://beascout.scouting.org/?utm_source=scouting&amp;utm_medium=join_header&amp;utm_campaign=ongoing">Join</a></li>
              <li><a target="_blank" href="https://donations.scouting.org/#/national/">Give</a></li>
              <li><a target="_blank" href="https://www.scoutshop.org/">Shop</a></li>
              <li><a target="_blank" href="https://my.scouting.org/">My.Scouting Login</a></li>
              {this.state.SubMenu &&
                <li href="#" className="drop-arrow pointer">
                  <Icon onClick={() => this.submenu(false)} type="up" />
                </li>
              }
            </ul>
          </div>
        </SmoothCollapse>

        <div className='nesa-header'>
          <Header>
            <Row type='flex' justify='space-around'>
              <Col xs={24} sm={6} md={4} lg={7} xl={7} >
                <Row type='flex'>
                  <Col xs={6} sm={6} md={6} lg={7} xl={6} >
                    <div className="logo-img">
                      <img src='/logo-lg.svg' />
                    </div>
                  </Col>
                  <Col xs={18} sm={18} md={2} lg={17} xl={18} className="hidden-md">
                    <div className='nesa-brand'>
                      <span className='title'>Scouting America</span>
                      <span className='slogan'>THE NATIONAL EAGLE SCOUT ASSOCIATION</span>
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col xs={24} sm={24} className="breadcrumbMenu visible-xs">
               
                <Menu
                  onClick={this.handleClick}
                  className="sub1Menu"
                  
                  // style={{ width: "100%" ,background: "#036"}}
                  // defaultSelectedKeys={['1']}
                  // defaultOpenKeys={['sub1']}
                  mode="inline"
                >
                  
                  {/* <SubMenu title="Menu" key="sub1" style={{background: "#036"}}>
                    <Menu.Item key="1"><a target="_blank" href="https://nesa.org/become-an-eagle">Become an Eagle</a></Menu.Item>
                    <Menu.Item key="2"><a target="_blank" href="https://nesa.org/for-eagle-scouts/">For Eagle Scouts</a></Menu.Item>
                    <Menu.Item key="3"><a target="_blank" href="https://nesa.org/support-scouting/">Support Scouting</a></Menu.Item>
                    <Menu.Item key="4"><a target="_blank" href="https://nesa.org/about-nesa/">About</a></Menu.Item>
                  </SubMenu> */}
                </Menu>
              </Col>
              <Col className='' sm={12} md={14} lg={13} xl={13}>
                {/* <ul className='nesa-menu'>
                  <li><a target="_blank" href="https://nesa.org/become-an-eagle">Become an Eagle</a></li>
                  <li><a target="_blank" href="https://nesa.org/for-eagle-scouts/">For Eagle Scouts</a></li>
                  <li><a target="_blank" href="https://nesa.org/support-scouting/">Support Scouting</a></li>
                  <li><a target="_blank" href="https://nesa.org/about-nesa/">About</a></li>
                </ul> */}
              </Col>
              <Col className='hidden-xs 'sm={6} md={6} lg={4} xl={4}>
                <Row type='flex' >
                  <div className='nesa-search'>
                    <Search
                      placeholder="Search"
                      className='header-search'
                      onSearch={value => console.log(value)}
                      enterButton
                    />
                  </div>
                  {!this.state.SubMenu &&
                    <div className='drop-arrow pointer'>
                      <svg onClick={() => this.submenu(true)} version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 24 7.4"><path className="st0" d="M16.6,0L12,4.6L7.4,0L6,1.4l6,6l6-6L16.6,0z"></path></svg>
                    </div>
                  }
                </Row>

              </Col>
            </Row>
          </Header>
        </div>
      </div>
    );
  }

}

function mapStateToProps(state) {
  return {
    logout: state.authenticationReducer.logout,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withRouter)(NESAHeader);




// WEBPACK FOOTER //
// ./src/components/Inc/NESAHeader.js